import { api_host, api_auth } from '../../common/globals/constants';

export const getCallMetrics = (objetivoId, period, userId, token, nodoId = 0) =>
    fetch(api_host + `/reporte/general/metricas_llamada/?objetivoId=${objetivoId}&token=${token}&key=${api_auth}&nodoId=${nodoId}&user=${userId}&t=${period}`)
        .then(response => response.json());
